'use strict';
const React = require('react');
const BaseComponent = require('../../../../../views/shared/base');

class OriginalPriceComponent extends BaseComponent {
    render() {
        return '';
    }
}

module.exports = OriginalPriceComponent;